module.exports = __webpack_public_path__ + "img/icone-trocar-senha.923af5e7.svg";